export default "__VITE_ASSET__Dz1q_MHy__"